import { Position } from '../../types'
import { useContext } from 'react'
import { CutterContext } from '../contexts/CutterContext'

export function useAbsolutePixelSize(width: number): Position {
  const { length } = useContext(CutterContext).audio

  return length / width
}
